import WishList from ".";

export const wishlistUserRoutes = (data) => {
  return [
    {
      path: "/:lang/wishlist",
      title: "wishlist",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: WishList,
    },
  ];
};
